export default {
  autoPlay: true, 
  loop: true, 
  muted: true, 
  playsInline: true,
  controlsList: 'nofullscreen',
  preload: 'auto'
}